import { render, staticRenderFns } from "./referral_questions.vue?vue&type=template&id=eea5ffd8&"
import script from "./referral_questions.vue?vue&type=script&lang=js&"
export * from "./referral_questions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports